
        module.exports = __webpack_public_path__ + "assets/images/klimaat-logo.d99c80c1.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1024,
            height: 1024,
            type: "svg",
            bytes: 2374,

            toString: function() {
                return src;
            }
        };
    